import { Button, Flex, Select } from 'antd';
import { I18n } from 'react-redux-i18n';

import Icon from 'components/Icon';
import { useCategory } from '../../context/CategoryContext';

const isMobile = window.innerWidth <= 845;

const TabNavigation = ({ filters, tableTypes, onSelect }) => {
  const { wineType } = useCategory();

  const formatLabel = (type) => {
    const isSpiritSelected = wineType === '2';

    let label = I18n.t('globalView.filters.typesTable.' + type);

    if (isSpiritSelected && type === 'wine') {
      label = I18n.t('globalView.filters.typesTable.spirit');
    }

    return label.toUpperCase();
  };

  if (isMobile) {
    return (
      <Select
        value={filters.tableTypeActive}
        className="selectTabNav"
        options={tableTypes.map((type) => ({
          value: type,
          label: formatLabel(type)
        }))}
        optionRender={(option) => (
          <div
            className="navButtonMobile"
            onClick={() => onSelect(option.value)}
          >
            {option.label}
          </div>
        )}
        suffixIcon={<Icon icon={'dropdown'} />}
      />
    );
  }

  return (
    <Flex gap="small">
      {tableTypes.map((type, index) => (
        <Button
          key={index}
          type={type === filters.tableTypeActive ? 'primary' : 'default'}
          size="middle"
          onClick={() => onSelect(type)}
          className="button-type-table"
        >
          {formatLabel(type)}
        </Button>
      ))}
    </Flex>
  );
};

export default TabNavigation;
